module.exports = __webpack_public_path__ + "img/18.73adb48c.jpg";